import { combineReducers } from 'redux';

import { appSettingsReducer, globalizationReducer, userProfileReducer } from '../features/common';

export const rootReducer = combineReducers({
  appSettings: appSettingsReducer,
  userProfile: userProfileReducer,
  globalization: globalizationReducer,
});
